export const LOGIN_PREFIX = 'login';
export const LOGIN_URL = '/' + LOGIN_PREFIX;

export const CANDIDATES_SEARCH_PAGE_PREFIX = 'candidates';
export const CANDIDATES_SEARCH_PAGE_URL = '/' + CANDIDATES_SEARCH_PAGE_PREFIX;

export const CANDIDATE_CHATBOT_SEARCH_PREFIX = 'candidate-search';
export const CANDIDATE_CHATBOT_SEARCH_URL = '/' + CANDIDATE_CHATBOT_SEARCH_PREFIX;

export const PROJECT_PAGE_PREFIX = 'project';
export const PROJECT_PAGE_URL = '/' + PROJECT_PAGE_PREFIX;

export const NLS_SEARCH_PREFIX = 'search-candidates';
export const NLS_SEARCH_URL = '/' + NLS_SEARCH_PREFIX;

export const SETTINGS_PREFIX = 'settings';
export const SETTINGS_URL = '/' + SETTINGS_PREFIX;

export const SETTINGS_BASIC_INFO_PREFIX = 'basic-info';
export const SETTINGS_BASIC_INFO_URL = SETTINGS_URL + '/' + SETTINGS_BASIC_INFO_PREFIX;

export const SETTINGS_MAILBOX_PREFIX = 'mailbox-and-emails';
export const SETTINGS_MAILBOX_URL = SETTINGS_URL + '/' + SETTINGS_MAILBOX_PREFIX;

export const SETTINGS_CONVERSATIONS_PREFIX = 'conversations';
export const SETTINGS_CONVERSATIONS_URL = SETTINGS_URL + '/' + SETTINGS_CONVERSATIONS_PREFIX;

export const SETTINGS_USER_MANAGEMENT_PREFIX = 'user-management';
export const SETTINGS_USER_MANAGEMENT_URL = SETTINGS_URL + '/' + SETTINGS_USER_MANAGEMENT_PREFIX;

export const SETTINGS_PLAN_BILLING_PREFIX = 'plan-and-billing';
export const SETTINGS_PLAN_BILLING_URL = SETTINGS_URL + '/' + SETTINGS_PLAN_BILLING_PREFIX;

export const PRICING_PAGE_PREFIX = 'pricing';
export const PRICING_PAGE_URL = '/' + PRICING_PAGE_PREFIX;

export const PLANS_PREFIX = 'plans';
export const PLANS_PAGE_URL = '/' + PLANS_PREFIX;

export const REPORTS_PREFIX = 'reports';
export const REPORTS_URL = '/' + REPORTS_PREFIX;

export const CONVERSION_AND_ROI_PREFIX = 'conversion-and-roi';
export const CONVERSION_AND_ROI_URL = '/' + CONVERSION_AND_ROI_PREFIX;

export const USAGE_REPORT_PREFIX = 'usage-report';
export const USAGE_REPORT_URL = '/' + USAGE_REPORT_PREFIX;

export const PROJECTS_REPORT_PREFIX = 'projects-report';
export const PROJECTS_REPORT_URL = '/' + PROJECTS_REPORT_PREFIX;

export const DASHBOARD = 'dashboard';
export const DASHBOARD_URL = '/' + DASHBOARD;

export const SLACK_OAUTH_CALLBACK_PREFIX = 'slack/oauth/callback';
export const SLACK_OAUTH_CALLBACK_URL = '/' + SLACK_OAUTH_CALLBACK_PREFIX;

export const DNA_PROFILE_PREFIX = 'dna-profile';
export const DNA_PROFILE_URL = '/' + DNA_PROFILE_PREFIX;
